var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.items)?_c('div',{staticClass:"test-properties"},[_vm._l((_vm.items),function(tp,index){return [_c('span',{key:tp.key},[_vm._v(_vm._s(tp.key)+": ")]),_c('span',{key:index},[_vm._v(_vm._s(tp.value))])]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }